import * as MUI from "@mui/material";
import * as MUIcons from "@mui/icons-material";
import { PreviewFotoSelecionadaProps } from "../types/mandado-facial.types";

export const PreviewFotoSelecionada: React.FC<PreviewFotoSelecionadaProps> = ({
  foto,
}) => {
  if (!foto) return null;

  return (
    <MUI.Box
      sx={{
        mt: 1,
        mb: 1,
        p: 2,
        border: "2px solid",
        borderColor: "primary.main",
        borderRadius: 2,
        backgroundColor: "background.paper",
        boxShadow: 2,
      }}
    >
      <MUI.Typography
        variant="subtitle2"
        sx={{
          mb: 2,
          fontWeight: "bold",
          color: "primary.main",
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <MUIcons.Image />
        Foto Selecionada para Análise
      </MUI.Typography>

      <MUI.Box
        sx={{
          display: "flex",
          flexDirection: ["column", "row"],
          gap: 2,
          alignItems: ["center", "flex-start"],
        }}
      >
        {/* Thumbnail */}
        <MUI.Box sx={{ position: "relative", display: "inline-block" }}>
          <MUI.Box
            component="img"
            src={URL.createObjectURL(foto)}
            alt="Foto selecionada"
            sx={{
              width: 120,
              height: 120,
              objectFit: "cover",
              borderRadius: 2,
              border: "3px solid",
              borderColor: "success.main",
              boxShadow: 3,
            }}
          />
          <MUI.Chip
            label="✓"
            size="small"
            sx={{
              position: "absolute",
              top: -8,
              right: -8,
              backgroundColor: "success.main",
              color: "white",
              fontWeight: "bold",
            }}
          />
        </MUI.Box>

        {/* Informações */}
        <MUI.Box sx={{ flex: 1, marginTop: 1 }}>
          <MUI.Stack spacing={2}>
            <MUI.Box>
              <MUI.Typography variant="body2" color="text.secondary">
                Nome do arquivo:
              </MUI.Typography>
              <MUI.Typography variant="body1" fontWeight="bold">
                {foto.name}
              </MUI.Typography>
            </MUI.Box>

            <MUI.Box sx={{ display: "flex", gap: 3, flexWrap: "wrap" }}>
              <MUI.Box sx={{ minWidth: "fit-content" }}>
                <MUI.Typography variant="body2" color="text.secondary">
                  Tamanho:
                </MUI.Typography>
                <MUI.Typography variant="body1" fontWeight="bold">
                  {(foto.size / 1024 / 1024).toFixed(2)} MB
                </MUI.Typography>
              </MUI.Box>

              <MUI.Box sx={{ minWidth: "fit-content" }}>
                <MUI.Typography variant="body2" color="text.secondary">
                  Tipo:
                </MUI.Typography>
                <MUI.Typography variant="body1" fontWeight="bold">
                  {foto.type}
                </MUI.Typography>
              </MUI.Box>
            </MUI.Box>
          </MUI.Stack>
        </MUI.Box>
      </MUI.Box>
    </MUI.Box>
  );
};
